<div class="container">
    <div class="col1">
        <div class="text">
            <img src="logo_hitec.png" alt="logo" width="200" height="130">
            <div style="margin-top: 20px;">
                <h1>Bienvenido a Hi-tec Medical</h1>
                <p>Sistema de administración de cobranza</p>
            </div>
        </div>
    </div>
    <div class="col2" [ngSwitch]="prompt">
        <!-- Login Form -->
        <form *ngSwitchCase="'login'" [formGroup]="loginForm" class="form-container">
            <h1>Iniciar sesión</h1>
            <mat-form-field appearance="outline">
                <mat-label>Correo electrónico</mat-label>
                <input matInput formControlName="email">
                <mat-icon matSuffix>person</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Contraseña</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" tabindex="-1">
                  <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="login()" [disabled]="isLoading">Entrar</button>
            <p class="errormessage" *ngIf="errorMessage">{{errorMessage}}</p>
            <p class="successmessage" *ngIf="successMessage">{{successMessage}}</p>
            <a mat-button (click)="goToResetPassword()" [style.display]="'none'">Olvidé mi contraseña</a>
        </form>

        <!-- MFA Form (Authenticator App) -->
        <form *ngSwitchCase="'mfaRequired'" [formGroup]="mfaForm" class="form-container">
            <h1>Verificación Requerida</h1>
            <p>Se ha enviado un código a su dispositivo de autenticación. Ingréselo para continuar.</p>
            <mat-form-field appearance="outline">
                <mat-label>Código de Verificación</mat-label>
                <input matInput formControlName="code">
                <mat-icon matSuffix>pin</mat-icon>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="verifyCode()" [disabled]="isLoading">Verificar</button>
            <p class="errormessage" *ngIf="errorMessage">{{errorMessage}}</p>
            <a mat-button (click)="returnToLogin()">Volver al inicio</a>
        </form>

        <!-- Email Code Form -->
        <form *ngSwitchCase="'emailCodeRequired'" [formGroup]="emailCodeForm" class="form-container">
            <h1>Verificación Requerida</h1>
            <p>Se ha enviado un código a su correo electrónico. Ingréselo para continuar.</p>
            <mat-form-field appearance="outline">
                <mat-label>Código de Verificación</mat-label>
                <input matInput formControlName="code">
                <mat-icon matSuffix>pin</mat-icon>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="verifyCode()" [disabled]="isLoading">Verificar</button>
            <p class="errormessage" *ngIf="errorMessage">{{errorMessage}}</p>
            <a mat-button (click)="returnToLogin()">Volver al inicio</a>
        </form>

        <!-- New Password Form -->
        <form *ngSwitchCase="'confirmPassword'" [formGroup]="confirmPasswordForm" class="form-container">
            <h1>Crear Nueva Contraseña</h1>
            <p>Su contraseña es temporal. Por favor, cree una nueva.</p>
            <mat-form-field appearance="outline">
                <mat-label>Nombre Completo</mat-label>
                <input matInput formControlName="name">
                <mat-icon matSuffix>badge</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Nueva Contraseña</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" tabindex="-1"><mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon></button>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Confirmar Contraseña</mat-label>
                <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword">
                <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" tabindex="-1"><mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon></button>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="confirmPass()" [disabled]="isLoading">Guardar</button>
            <p class="errormessage" *ngIf="errorMessage">{{errorMessage}}</p>
        </form>

        <!-- Reset Password Request Form -->
        <form *ngSwitchCase="'resetPasswordRequest'" [formGroup]="resetPasswordForm" class="form-container">
            <h1>Reiniciar Contraseña</h1>
            <p>Ingrese su correo electrónico para recibir un código de verificación.</p>
            <mat-form-field appearance="outline">
                <mat-label>Correo electrónico</mat-label>
                <input matInput formControlName="email">
                <mat-icon matSuffix>email</mat-icon>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="requestPasswordReset()" [disabled]="isLoading">Enviar Código</button>
            <p class="errormessage" *ngIf="errorMessage">{{errorMessage}}</p>
            <a mat-button (click)="returnToLogin()">Volver al inicio</a>
        </form>

        <!-- Reset Password Confirm Form -->
        <form *ngSwitchCase="'resetPasswordConfirm'" [formGroup]="resetPasswordConfirmForm" class="form-container">
            <h1>Confirmar Nueva Contraseña</h1>
            <p>Ingrese el código de su correo y su nueva contraseña.</p>
            <mat-form-field appearance="outline">
                <mat-label>Código de Verificación</mat-label>
                <input matInput formControlName="code">
                <mat-icon matSuffix>pin</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Nueva Contraseña</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" tabindex="-1"><mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon></button>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Confirmar Contraseña</mat-label>
                <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword">
                <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" tabindex="-1"><mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon></button>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="confirmNewPassword()" [disabled]="isLoading">Actualizar Contraseña</button>
            <p class="errormessage" *ngIf="errorMessage">{{errorMessage}}</p>
            <p class="successmessage" *ngIf="successMessage">{{successMessage}}</p>
            <a mat-button (click)="returnToLogin()">Volver al inicio</a>
        </form>
    </div>
</div>

<div class="footer">
    <span class="footer-left">Hitec Cobranza</span>
    <p>DoHealth 2025</p>
</div>